import React, { FC } from 'react'

import { IRecapProps } from './UserForm.props'

export const Recap: FC<IRecapProps> = ({ list }) => {

  return (
    <div className="user-form-confirmation__wrapper">
      <p>{`Are you sure you want to assign the project${list.length > 1 ? 's' : ''}?`}</p>
      {
        list.map(({ projectId, projectName, artistName }) => (
          <dl key={projectId} className="user-form-confirmation__item">
            <dt>{artistName}</dt>
            <dd>{projectName}</dd>
          </dl>
        ))
      }
    </div>
  )
}
